var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9683 2.11587V0.304151C11.9683 0.14712 11.7878 0.0604011 11.666 0.156495L1.10033 8.40884C1.01056 8.47865 0.937919 8.56804 0.887952 8.6702C0.837986 8.77235 0.812012 8.88457 0.812012 8.99829C0.812012 9.11201 0.837986 9.22423 0.887952 9.32639C0.937919 9.42854 1.01056 9.51793 1.10033 9.58774L11.666 17.8401C11.7902 17.9362 11.9683 17.8495 11.9683 17.6924V15.8807C11.9683 15.7659 11.9144 15.6557 11.8253 15.5854L3.38783 8.99946L11.8253 2.41118C11.9144 2.34087 11.9683 2.23071 11.9683 2.11587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previous-icon.6042cb3f2a8b4fcb7bac4e91d5fd5974.svg";
export { ForwardRef as ReactComponent };